/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _circle, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _circle2, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _circle3, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _circle4, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _circle5, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _circle6, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _circle7, _path319, _path320, _path321, _path322, _circle8, _circle9, _path323, _circle0, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339;
const didWarnAboutDeprecation = {};
const TriangleDownOutline = /*#__PURE__*/React.forwardRef(function TriangleDownOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2.1245,4.4883l13.0195,23.9868c.1865.3438.5212.5249.856.5249.3345,0,.6689-.1812.8555-.5249L29.875,4.4883c.0862-.1582.1255-.3257.125-.4883-.0017-.5229-.4114-1-.9805-1H2.9802c-.5691,0-.9788.4771-.9802,1-.0005.1626.0386.3301.1245.4883Zm25.1985.5117l-11.323,20.8677L4.677,5h22.646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleDownOutline.propTypes = iconPropTypes;
}
const TriangleDownSolid = /*#__PURE__*/React.forwardRef(function TriangleDownSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.0194,3c.5692,0,.979.4772.9806,1,.0005.1628-.0388.3299-.1249.4885l-13.0196,23.9867c-.1865.3435-.521.5248-.8555.5248s-.6694-.1812-.8559-.5248L2.1246,4.4885c-.0861-.1586-.1251-.3257-.1246-.4885.0016-.5228.4111-1,.9803-1h26.0391Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleDownSolid.propTypes = iconPropTypes;
}
const TriangleLeftOutline = /*#__PURE__*/React.forwardRef(function TriangleLeftOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.5117,2.1245L3.5249,15.144c-.3438.1865-.5249.5212-.5249.856,0,.3345.1812.6689.5249.8555l23.9868,13.0195c.1582.0862.3257.1255.4883.125.5229-.0017,1-.4114,1-.9805V2.9802c0-.5691-.4771-.9788-1-.9802-.1626-.0005-.3301.0386-.4883.1245Zm-.5117,25.1985L6.1323,16,27,4.677v22.646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleLeftOutline.propTypes = iconPropTypes;
}
const TriangleLeftSolid = /*#__PURE__*/React.forwardRef(function TriangleLeftSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,29.0194c0,.5692-.4772.979-1,.9806-.1628.0005-.3299-.0388-.4885-.1249L3.5248,16.8556c-.3435-.1865-.5248-.521-.5248-.8555s.1812-.6694.5248-.8559L27.5115,2.1246c.1586-.0861.3257-.1251.4885-.1246.5228.0016,1,.4111,1,.9803v26.0391Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleLeftSolid.propTypes = iconPropTypes;
}
const TriangleOutline = /*#__PURE__*/React.forwardRef(function TriangleOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.8755,27.5117L16.856,3.5249c-.1865-.3438-.5212-.5249-.856-.5249-.3345,0-.6689.1812-.8555.5249L2.125,27.5117c-.0862.1582-.1255.3257-.125.4883.0017.5229.4114,1,.9805,1h26.0393c.5691,0,.9788-.4771.9802-1,.0005-.1626-.0386-.3301-.1245-.4883Zm-25.1985-.5117L16,6.1323l11.323,20.8677H4.677Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleOutline.propTypes = iconPropTypes;
}
const TriangleRightOutline = /*#__PURE__*/React.forwardRef(function TriangleRightOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.4883,29.8755l23.9868-13.0195c.3438-.1865.5249-.5212.5249-.856,0-.3345-.1812-.6689-.5249-.8555L4.4883,2.125c-.1582-.0862-.3257-.1255-.4883-.125-.5229.0017-1,.4114-1,.9805v26.0393c0,.5691.4771.9788,1,.9802.1626.0005.3301-.0386.4883-.1245Zm.5117-25.1985l20.8677,11.323L5,27.323V4.677Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleRightOutline.propTypes = iconPropTypes;
}
const TriangleRightSolid = /*#__PURE__*/React.forwardRef(function TriangleRightSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m3,2.9806c0-.5692.4772-.979,1-.9806.1628-.0005.3299.0388.4885.1249l23.9867,13.0196c.3435.1865.5248.521.5248.8555s-.1812.6694-.5248.8559L4.4885,29.8754c-.1586.0861-.3257.1251-.4885.1246-.5228-.0016-1-.4111-1-.9803V2.9806Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleRightSolid.propTypes = iconPropTypes;
}
const TriangleSolid = /*#__PURE__*/React.forwardRef(function TriangleSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2.9806,29c-.5692,0-.979-.4772-.9806-1-.0005-.1628.0388-.3299.1249-.4885L15.1444,3.5248c.1865-.3435.521-.5248.8555-.5248s.6694.1812.8559.5248l13.0195,23.9867c.0861.1586.1251.3257.1246.4885-.0016.5228-.4111,1-.9803,1H2.9806Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TriangleSolid.propTypes = iconPropTypes;
}
const Trigger = /*#__PURE__*/React.forwardRef(function Trigger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2,19l1.4,1.4,5.6-5.6,5.6,5.6,1.4-1.4-7-7-7,7ZM28.6,11.6l-5.6,5.6-5.6-5.6-1.4,1.4,7,7,7-7-1.4-1.4ZM9,22c-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2-.8954-2-2-2ZM23,10c1.1046,0,2-.8954,2-2s-.8954-2-2-2-2,.8954-2,2,.8954,2,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Trigger.propTypes = iconPropTypes;
}
const Trophy = /*#__PURE__*/React.forwardRef(function Trophy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Trophy.propTypes = iconPropTypes;
}
const TrophyFilled = /*#__PURE__*/React.forwardRef(function TrophyFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrophyFilled.propTypes = iconPropTypes;
}
const TropicalStorm = /*#__PURE__*/React.forwardRef(function TropicalStorm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalStorm.propTypes = iconPropTypes;
}
const TropicalStormModelTracks = /*#__PURE__*/React.forwardRef(function TropicalStormModelTracks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8188,6.65c.1163-.1211,1.8643-1.919,2.8882-2.9434A1,1,0,0,0,17,2C11.812,2,2,4.2988,2,13a7.8938,7.8938,0,0,0,3.1812,6.35c-.1612.1675-1.9507,2.0054-2.8882,2.9429A1,1,0,0,0,3,24c5.188,0,15-2.2988,15-11A7.8927,7.8927,0,0,0,14.8188,6.65ZM9.7065,20.793a20.94,20.94,0,0,1-4.0932.9853c.1621-.166,2.7685-2.9053,2.7685-2.9053l-1.1743-.6074A5.9064,5.9064,0,0,1,4,13c0-3.667,2.1177-6.2886,6.2935-7.793a20.94,20.94,0,0,1,4.0932-.9853c-.227.2324-2.769,2.9057-2.769,2.9057l1.1748.607A5.9075,5.9075,0,0,1,16,13C16,16.667,13.8823,19.2886,9.7065,20.793Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17l-5-5-5,5,1.4126,1.4155L24,15.8325V19a9.01,9.01,0,0,1-9,9H12v2h3A11.0125,11.0125,0,0,0,26,19V15.8325l2.5859,2.5816Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalStormModelTracks.propTypes = iconPropTypes;
}
const TropicalStormTracks = /*#__PURE__*/React.forwardRef(function TropicalStormTracks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalStormTracks.propTypes = iconPropTypes;
}
const TropicalWarning = /*#__PURE__*/React.forwardRef(function TropicalWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalWarning.propTypes = iconPropTypes;
}
const Tsq = /*#__PURE__*/React.forwardRef(function Tsq({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H30V28H19z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H30V24H19z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20h-11V12h11v8Zm-9-2h7v-4h-7v4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H30V10H19z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H30V6H19z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tsq.propTypes = iconPropTypes;
}
const Tsunami = /*#__PURE__*/React.forwardRef(function Tsunami({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tsunami.propTypes = iconPropTypes;
}
const Tsv = /*#__PURE__*/React.forwardRef(function Tsv({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H14v4h4a2.002,2.002,0,0,1,2,2v4A2.002,2.002,0,0,1,18,23Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tsv.propTypes = iconPropTypes;
}
const Tuning = /*#__PURE__*/React.forwardRef(function Tuning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m24,30v-4.1c2.3-.5,4-2.5,4-4.9,0-2.4-1.7-4.4-4-4.9V2s-2,0-2,0v14.1c-2.3.5-4,2.5-4,4.9,0,2.4,1.7,4.4,4,4.9v4.1s2,0,2,0Zm-4-9c0-1.7,1.3-3,3-3s3,1.3,3,3c0,1.7-1.3,3-3,3s-3-1.3-3-3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m8,2v4.1c-2.3.5-4,2.5-4,4.9,0,2.4,1.7,4.4,4,4.9v14.1s2,0,2,0v-14.1c2.3-.5,4-2.5,4-4.9,0-2.4-1.7-4.4-4-4.9V2s-2,0-2,0Zm4,9c0,1.7-1.3,3-3,3s-3-1.3-3-3,1.3-3,3-3,3,1.3,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tuning.propTypes = iconPropTypes;
}
const TwoFactorAuthentication = /*#__PURE__*/React.forwardRef(function TwoFactorAuthentication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24V28h4V16H24V8a4.0045,4.0045,0,0,0-4-4V2a6.0067,6.0067,0,0,1,6,6v6h2a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TwoFactorAuthentication.propTypes = iconPropTypes;
}
const TwoPersonLift = /*#__PURE__*/React.forwardRef(function TwoPersonLift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.96,30l-1.9215-6.7253a1.0008,1.0008,0,0,1,.3369-1.0554L29.874,18.62,28.52,13.2014l-2.7382,3.4234A1.0026,1.0026,0,0,1,25,17H20V15h4.52l3.6993-4.6248a1,1,0,0,1,1.7509.3824l2,8a.9989.9989,0,0,1-.3447,1.0232l-4.48,3.5845,1.7389,6.0854Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23,5.5A3.5,3.5,0,1,1,26.5,9,3.5042,3.5042,0,0,1,23,5.5Zm2,0A1.5,1.5,0,1,0,26.5,4,1.5017,1.5017,0,0,0,25,5.5Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04,30l1.9215-6.7253a1.0013,1.0013,0,0,0-.3369-1.0555L2.126,18.62l1.3545-5.4185,2.7382,3.4234A1.0026,1.0026,0,0,0,7,17h5V15H7.4805L3.7812,10.3752a1,1,0,0,0-1.7509.3824l-2,8A.9989.9989,0,0,0,.375,19.7808l4.4805,3.5844-1.739,6.0855Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,9A3.5,3.5,0,1,1,9,5.5,3.5042,3.5042,0,0,1,5.5,9Zm0-5A1.5,1.5,0,1,0,7,5.5,1.5017,1.5017,0,0,0,5.5,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TwoPersonLift.propTypes = iconPropTypes;
}
const Txt = /*#__PURE__*/React.forwardRef(function Txt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Txt.propTypes = iconPropTypes;
}
const TxtReference = /*#__PURE__*/React.forwardRef(function TxtReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TxtReference.propTypes = iconPropTypes;
}
const TypePattern = /*#__PURE__*/React.forwardRef(function TypePattern({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30H3a1,1,0,0,1-.8945-1.4473l4-8a1.0412,1.0412,0,0,1,1.789,0l4,8A1,1,0,0,1,11,30ZM4.6182,28H9.3818L7,23.2363Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6.001L28,4Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,12ZM7,4a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TypePattern.propTypes = iconPropTypes;
}
const Types = /*#__PURE__*/React.forwardRef(function Types({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Types.propTypes = iconPropTypes;
}
const QU1 = /*#__PURE__*/React.forwardRef(function QU1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QU1.propTypes = iconPropTypes;
}
const QU2 = /*#__PURE__*/React.forwardRef(function QU2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H17V17a2,2,0,0,1,2-2h4V11H17V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H19v4h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QU2.propTypes = iconPropTypes;
}
const QU3 = /*#__PURE__*/React.forwardRef(function QU3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9H17v2h6v4H18v2h5v4H17v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,23,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QU3.propTypes = iconPropTypes;
}
const Umbrella = /*#__PURE__*/React.forwardRef(function Umbrella({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Umbrella.propTypes = iconPropTypes;
}
const Undefined = /*#__PURE__*/React.forwardRef(function Undefined({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H21V18H11z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Undefined.propTypes = iconPropTypes;
}
const UndefinedFilled = /*#__PURE__*/React.forwardRef(function UndefinedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11 14H21V18H11z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UndefinedFilled.propTypes = iconPropTypes;
}
const Undo = /*#__PURE__*/React.forwardRef(function Undo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Undo.propTypes = iconPropTypes;
}
const UngroupObjects = /*#__PURE__*/React.forwardRef(function UngroupObjects({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UngroupObjects.propTypes = iconPropTypes;
}
const Unknown = /*#__PURE__*/React.forwardRef(function Unknown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22.5",
    r: "1.5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2 c2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unknown.propTypes = iconPropTypes;
}
const UnknownFilled = /*#__PURE__*/React.forwardRef(function UnknownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5 S16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2 c-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125 C21.125,15.358,19.342,17.182,17.125,17.248z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21 z M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5 c0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UnknownFilled.propTypes = iconPropTypes;
}
const Unlink = /*#__PURE__*/React.forwardRef(function Unlink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.59H7V8.42H5z",
    transform: "rotate(-45.01 5.996 6.005)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.58H27V28.409999999999997H25z",
    transform: "rotate(-44.99 25.995 25.999)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13V6H11z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H6V13H2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19H30V21H26z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H21V30H19z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M16.58,21.07l-3.71,3.72a4,4,0,1,1-5.66-5.66l3.72-3.72L9.51,14,5.8,17.72a6,6,0,0,0-.06,8.54A6,6,0,0,0,10,28a6.07,6.07,0,0,0,4.32-1.8L18,22.49Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41,10.93l3.72-3.72a4,4,0,1,1,5.66,5.66l-3.72,3.72L22.49,18l3.71-3.72a6,6,0,0,0,.06-8.54A6,6,0,0,0,22,4a6.07,6.07,0,0,0-4.32,1.8L14,9.51Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unlink.propTypes = iconPropTypes;
}
const Unlocked = /*#__PURE__*/React.forwardRef(function Unlocked({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
      d: "M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1 V8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unlocked.propTypes = iconPropTypes;
}
const Unsaved = /*#__PURE__*/React.forwardRef(function Unsaved({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6 c0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unsaved.propTypes = iconPropTypes;
}
const UpToTop = /*#__PURE__*/React.forwardRef(function UpToTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H28V10H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UpToTop.propTypes = iconPropTypes;
}
const UpdateNow = /*#__PURE__*/React.forwardRef(function UpdateNow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24,31a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,24,31Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,24,19Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A12.0134,12.0134,0,0,1,4,16H2A14.0158,14.0158,0,0,0,16,30Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12,8H7.0784A11.9843,11.9843,0,0,1,28,16h2A13.9778,13.9778,0,0,0,6,6.2344V2H4v8h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UpdateNow.propTypes = iconPropTypes;
}
const Upgrade = /*#__PURE__*/React.forwardRef(function Upgrade({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21,24H11a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V26A2,2,0,0,0,21,24Zm0,4H11V26H21Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28.707,14.293l-12-12a.9994.9994,0,0,0-1.414,0l-12,12A1,1,0,0,0,4,16H9v4a2.0023,2.0023,0,0,0,2,2H21a2.0027,2.0027,0,0,0,2-2V16h5a1,1,0,0,0,.707-1.707ZM21,14v6H11V14H6.4141L16,4.4141,25.5859,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Upgrade.propTypes = iconPropTypes;
}
const Upload = /*#__PURE__*/React.forwardRef(function Upload({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
      d: "M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4z"
    })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
      d: "M3,4V2h10v2h1V2c0-0.6-0.4-1-1-1H3C2.4,1,2,1.4,2,2v2H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Upload.propTypes = iconPropTypes;
}
const Upstream = /*#__PURE__*/React.forwardRef(function Upstream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m10,24c0,3.3137,2.6863,6,6,6s6-2.6863,6-6-2.6863-6-6-6-6,2.6863-6,6Zm2,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4-1.7944,4-4,4-4-1.7944-4-4Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m30,5c0-1.6567-1.3433-3-3-3s-3,1.3433-3,3c0,1.3042.8374,2.4028,2,2.8164v5.1836c0,1.7217-.752,3.3438-2,4.4673v-2.4673h-2v6h6v-2h-2.7168c1.6938-1.4995,2.7168-3.6816,2.7168-6v-5.1836c1.1626-.4136,2-1.5122,2-2.8164Zm-3,1c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m18.586,11.5859l-1.5859,1.5859v-5.3555c1.1626-.4136,2-1.5122,2-2.8164,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3c0,1.3042.8374,2.4028,2,2.8164v5.3555l-1.5859-1.5859-1.4141,1.4141,4,4,4-4-1.4141-1.4141Zm-2.5859-7.5859c.5522,0,1,.4478,1,1s-.4478,1-1,1-1-.4478-1-1,.4478-1,1-1Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m8,15v2.4673c-1.248-1.1235-2-2.7456-2-4.4673v-5.1836c1.1626-.4136,2-1.5122,2-2.8164,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3c0,1.3042.8374,2.4028,2,2.8164v5.1836c0,2.3184,1.0229,4.5005,2.7168,6h-2.7168v2h6v-6h-2Zm-3-11c.5522,0,1,.4478,1,1s-.4478,1-1,1-1-.4478-1-1,.4478-1,1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Upstream.propTypes = iconPropTypes;
}
const Url = /*#__PURE__*/React.forwardRef(function Url({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,15v-4c0-1.103-.8975-2-2-2h-6v14h2v-6h1.4807l2.3345,6h2.1453l-2.3331-6h.3726c1.1025,0,2-.8975,2-2Zm-6-4h4v4h-4v-4Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8,23h-4c-1.103,0-2-.8975-2-2v-12h2v12h4v-12h2v12c0,1.1025-.897,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Url.propTypes = iconPropTypes;
}
const UsageIncludedUseCase = /*#__PURE__*/React.forwardRef(function UsageIncludedUseCase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,28V5.8281l7.5859,7.5859,1.4141-1.4141L12,2,2,12l1.4143,1.4141,7.5857-7.5854v22.1714c0,1.1045.8955,2,2,2h15v-2h-15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UsageIncludedUseCase.propTypes = iconPropTypes;
}
const Usb = /*#__PURE__*/React.forwardRef(function Usb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H15V12H12z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H20V12H17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Usb.propTypes = iconPropTypes;
}
const UseCaseDefinition = /*#__PURE__*/React.forwardRef(function UseCaseDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22.0735,21.9922c1.7068,0,2.9407-.7773,3.5151-2.3325l-1.6561-.7942c-.3212.7942-.828,1.386-1.859,1.386-1.2002,0-1.8086-.8284-1.8086-2.062v-1.6057c0-1.2341.6084-2.0787,1.8086-2.0787.9294,0,1.4871.5409,1.6899,1.2845l1.7748-.7947c-.524-1.386-1.6903-2.2307-3.4647-2.2307-2.603,0-4.0735,1.7744-4.0735,4.5969,0,2.8394,1.4705,4.6311,4.0735,4.6311Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11.5126,21.9922c3.3129,0,4.5468-1.572,4.5468-5.0369v-6.9631h-2.1973v7.2507c0,1.8422-.6423,2.772-2.3324,2.772s-2.3324-.9298-2.3324-2.772v-7.2507h-2.1973v6.9631c0,3.4648,1.2,5.0369,4.5126,5.0369Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UseCaseDefinition.propTypes = iconPropTypes;
}
const UseCaseUsage = /*#__PURE__*/React.forwardRef(function UseCaseUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22.0735,21.9922c1.7068,0,2.9407-.7773,3.5151-2.3325l-1.6561-.7942c-.3212.7942-.828,1.386-1.859,1.386-1.2002,0-1.8086-.8284-1.8086-2.062v-1.6057c0-1.2341.6084-2.0787,1.8086-2.0787.9294,0,1.4871.5409,1.6899,1.2845l1.7748-.7947c-.524-1.386-1.6903-2.2307-3.4647-2.2307-2.603,0-4.0735,1.7744-4.0735,4.5969,0,2.8394,1.4705,4.6311,4.0735,4.6311Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11.5126,21.9922c3.3129,0,4.5468-1.572,4.5468-5.0369v-6.9631h-2.1973v7.2507c0,1.8422-.6423,2.772-2.3324,2.772s-2.3324-.9298-2.3324-2.772v-7.2507h-2.1973v6.9631c0,3.4648,1.2,5.0369,4.5126,5.0369Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UseCaseUsage.propTypes = iconPropTypes;
}
const User = /*#__PURE__*/React.forwardRef(function User({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c1.4,0,2.5,1.1,2.5,2.5S9.4,7,8,7S5.5,5.9,5.5,4.5S6.6,2,8,2 M8,1C6.1,1,4.5,2.6,4.5,4.5S6.1,8,8,8s3.5-1.6,3.5-3.5 S9.9,1,8,1z"
    })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
      d: "M13,15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1,10,4,11.1,4,12.5V15H3v-2.5C3,10.6,4.6,9,6.5,9h3c1.9,0,3.5,1.6,3.5,3.5V15z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V25a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v5H6V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  User.propTypes = iconPropTypes;
}
const UserAccess = /*#__PURE__*/React.forwardRef(function UserAccess({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12a1.9922,1.9922,0,0,0-.5117.0742L28.4331,11.019a3.8788,3.8788,0,0,0,0-4.038l1.0552-1.0552a2.0339,2.0339,0,1,0-1.4141-1.4141L27.019,5.5669a3.8788,3.8788,0,0,0-4.038,0L21.9258,4.5117a2.0339,2.0339,0,1,0-1.4141,1.4141L21.5669,6.981a3.8788,3.8788,0,0,0,0,4.038l-1.0552,1.0552a2.0339,2.0339,0,1,0,1.4141,1.4141l1.0552-1.0552a3.8788,3.8788,0,0,0,4.038,0l1.0552,1.0552A1.9957,1.9957,0,1,0,30,12ZM23,9a2,2,0,1,1,2,2A2.0025,2.0025,0,0,1,23,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAccess.propTypes = iconPropTypes;
}
const UserAccessLocked = /*#__PURE__*/React.forwardRef(function UserAccessLocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,8v-3c0-2.2056-1.7944-4-4-4s-4,1.7944-4,4v3c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2Zm-6-3c0-1.1025.8972-2,2-2s2,.8975,2,2v3h-4v-3Zm-2,11v-6h8v6h-8Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5h-2v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3,1.3431-3,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAccessLocked.propTypes = iconPropTypes;
}
const UserAccessUnlocked = /*#__PURE__*/React.forwardRef(function UserAccessUnlocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5h-2v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3,1.3431-3,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,8h-6v-3c0-1.1025.8972-2,2-2s2,.8975,2,2h2c0-2.2056-1.7944-4-4-4s-4,1.7944-4,4v3c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2Zm0,8h-8v-6h8v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAccessUnlocked.propTypes = iconPropTypes;
}
const UserActivity = /*#__PURE__*/React.forwardRef(function UserActivity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23h-.0215a1.0016,1.0016,0,0,1-.94-.7256L20.8711,11.19l-1.9346,5.1607A1.0005,1.0005,0,0,1,18,17H14V15h3.3066l2.7569-7.3511a1.0005,1.0005,0,0,1,1.8984.0762l3.1113,10.8921,1.9786-5.9336A.9988.9988,0,0,1,28,12h4v2H28.7207l-2.7725,8.3164A.9984.9984,0,0,1,25,23Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H13V23a3.0033,3.0033,0,0,0-3-3H6a3.0033,3.0033,0,0,0-3,3v7H1V23a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M8,8a3,3,0,1,1-3,3A3,3,0,0,1,8,8M8,6a5,5,0,1,0,5,5A5,5,0,0,0,8,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserActivity.propTypes = iconPropTypes;
}
const UserAdmin = /*#__PURE__*/React.forwardRef(function UserAdmin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAdmin.propTypes = iconPropTypes;
}
const UserAvatar = /*#__PURE__*/React.forwardRef(function UserAvatar({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5 C9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5 s6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z"
    })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
      d: "M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5 S8.8,7,8,7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAvatar.propTypes = iconPropTypes;
}
const UserAvatarFilled = /*#__PURE__*/React.forwardRef(function UserAvatarFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAvatarFilled.propTypes = iconPropTypes;
}
const UserAvatarFilledAlt = /*#__PURE__*/React.forwardRef(function UserAvatarFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAvatarFilledAlt.propTypes = iconPropTypes;
}
const UserCertification = /*#__PURE__*/React.forwardRef(function UserCertification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserCertification.propTypes = iconPropTypes;
}
const UserData = /*#__PURE__*/React.forwardRef(function UserData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8H30V16H28z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5H25V16H23z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H20V16H18z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V24a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v6H2V24a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9a3,3,0,1,1-3,3A3,3,0,0,1,9,9M9,7a5,5,0,1,0,5,5A5,5,0,0,0,9,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserData.propTypes = iconPropTypes;
}
const UserFavorite = /*#__PURE__*/React.forwardRef(function UserFavorite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,12a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L25.0019,21l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,27.303,12Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M2,30H4V25a5.0059,5.0059,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v5h2V25a7.0082,7.0082,0,0,0-7-7H9a7.0082,7.0082,0,0,0-7,7Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFavorite.propTypes = iconPropTypes;
}
const UserFavoriteAlt = /*#__PURE__*/React.forwardRef(function UserFavoriteAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7663,4.2558A4.2121,4.2121,0,0,0,23,4.0321a4.2121,4.2121,0,0,0-5.7663.2237,4.319,4.319,0,0,0,0,6.0447L22.998,16.14,23,16.1376l.002.0019,5.7643-5.839A4.319,4.319,0,0,0,28.7663,4.2558ZM27.342,8.8948l-4.34,4.3973L23,13.29l-.002.002-4.34-4.3973a2.3085,2.3085,0,0,1,0-3.2338,2.2639,2.2639,0,0,1,3.1561,0l1.181,1.2074L23,6.8634l.0049.005,1.181-1.2074a2.2639,2.2639,0,0,1,3.1561,0A2.3085,2.3085,0,0,1,27.342,8.8948Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFavoriteAlt.propTypes = iconPropTypes;
}
const UserFavoriteAltFilled = /*#__PURE__*/React.forwardRef(function UserFavoriteAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4938,3a3.4735,3.4735,0,0,0-2.48,1.0393l-.5111.5228-.5161-.5228a3.4792,3.4792,0,0,0-4.96,0,3.59,3.59,0,0,0,0,5.0251l5.4766,5.5427,5.4716-5.5427a3.59,3.59,0,0,0,0-5.0251A3.4738,3.4738,0,0,0,26.4938,3Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFavoriteAltFilled.propTypes = iconPropTypes;
}
const UserFeedback = /*#__PURE__*/React.forwardRef(function UserFeedback({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,3h10c1.1035,0,2,.8965,2,2v6c0,1.1035-.8965,2-2,2h-2.4229s-1.7314,3-1.7314,3l-1.7324-1,2.3096-4h3.5771s0-6,0-6h-10s0,6,0,6h3v2h-3c-1.1035,0-2-.8965-2-2v-6c0-1.1035.8965-2,2-2Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m15,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5H1v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3c.0019-1.6561,1.3439-2.9981,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFeedback.propTypes = iconPropTypes;
}
const UserFilled = /*#__PURE__*/React.forwardRef(function UserFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26V25a7.0082,7.0082,0,0,0-7-7H13a7.0082,7.0082,0,0,0-7,7Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9a7,7,0,1,0,7-7A7,7,0,0,0,9,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFilled.propTypes = iconPropTypes;
}
const UserFollow = /*#__PURE__*/React.forwardRef(function UserFollow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFollow.propTypes = iconPropTypes;
}
const UserIdentification = /*#__PURE__*/React.forwardRef(function UserIdentification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18H18a2.0023,2.0023,0,0,1-2-2V4a2.002,2.002,0,0,1,2-2H30a2.0023,2.0023,0,0,1,2,2V16A2.0027,2.0027,0,0,1,30,18ZM18,4V16H30.001L30,4Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H13V26a2.9465,2.9465,0,0,0-3-3H6a2.9465,2.9465,0,0,0-3,3v4H1V26a4.9514,4.9514,0,0,1,5-5h4a4.9514,4.9514,0,0,1,5,5Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M8,11a3,3,0,0,1,0,6,3,3,0,0,1,0-6M8,9A5,5,0,0,0,8,19,5,5,0,0,0,8,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserIdentification.propTypes = iconPropTypes;
}
const UserMilitary = /*#__PURE__*/React.forwardRef(function UserMilitary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserMilitary.propTypes = iconPropTypes;
}
const UserMultiple = /*#__PURE__*/React.forwardRef(function UserMultiple({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V25a5.0057,5.0057,0,0,0-5-5V18a7.0078,7.0078,0,0,1,7,7Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2V4a5,5,0,0,1,0,10v2A7,7,0,0,0,20,2Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserMultiple.propTypes = iconPropTypes;
}
const UserOnline = /*#__PURE__*/React.forwardRef(function UserOnline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "16",
    r: "4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserOnline.propTypes = iconPropTypes;
}
const UserProfile = /*#__PURE__*/React.forwardRef(function UserProfile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H32V6H22z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9H32V11H22z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H29V16H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserProfile.propTypes = iconPropTypes;
}
const UserRole = /*#__PURE__*/React.forwardRef(function UserRole({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserRole.propTypes = iconPropTypes;
}
const UserService = /*#__PURE__*/React.forwardRef(function UserService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23.019,10.4332c-.595.3514-1.2795.5668-2.019.5668-2.2056,0-4-1.7944-4-4,0-.3557.0615-.6943.1492-1.0228l2.4368,2.4368.0005-.0004c.3621.3621.8621.5864,1.4136.5864,1.103,0,2-.897,2-2,0-.5515-.2242-1.0515-.5864-1.4136l.0005-.0004-2.4368-2.4368c.3284-.0875.667-.1491,1.0227-.1491,2.2056,0,4,1.7944,4,4,0,.7396-.2155,1.4241-.5669,2.0191l5.5669,5.5668-1.4141,1.4141-5.5669-5.5668Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5h-2v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3c.0019-1.6561,1.3439-2.9981,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserService.propTypes = iconPropTypes;
}
const UserServiceDesk = /*#__PURE__*/React.forwardRef(function UserServiceDesk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M25.334,11.95l1.2055-1.206a1.178,1.178,0,0,1,1.2593-.2584l1.4693.5868A1.1736,1.1736,0,0,1,30,12.1489v2.692A1.1681,1.1681,0,0,1,28.8229,16l-.05-.0015C18.4775,15.3578,16.4,6.6357,16.0073,3.2976a1.1681,1.1681,0,0,1,1.0315-1.29A1.1492,1.1492,0,0,1,17.1751,2h2.5994a1.1626,1.1626,0,0,1,1.0764.7322l.5866,1.47a1.1635,1.1635,0,0,1-.2529,1.26L19.9791,6.668S20.6733,11.3682,25.334,11.95Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserServiceDesk.propTypes = iconPropTypes;
}
const UserSettings = /*#__PURE__*/React.forwardRef(function UserSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSettings.propTypes = iconPropTypes;
}
const UserSimulation = /*#__PURE__*/React.forwardRef(function UserSimulation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 12.866H29.232V14.866H25.232z",
    transform: "rotate(30 27.232 13.866)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V10H26z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2.768 12.866H6.768V14.866H2.768z",
    transform: "rotate(150 4.768 13.866)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V25a5.0059,5.0059,0,0,0-5-5H13a5.0059,5.0059,0,0,0-5,5v5H6V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 3.134H29.232V5.134H25.232z",
    transform: "rotate(-30 27.232 4.134)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H6V10H2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M2.768 3.134H6.768V5.134H2.768z",
    transform: "rotate(-150 4.768 4.134)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSimulation.propTypes = iconPropTypes;
}
const UserSpeaker = /*#__PURE__*/React.forwardRef(function UserSpeaker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSpeaker.propTypes = iconPropTypes;
}
const UserSponsor = /*#__PURE__*/React.forwardRef(function UserSponsor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8301 13.3662L30.8301 11.6338 28 13.2681 28 10 26 10 26 13.2676 23.1699 11.6338 22.1699 13.3662 25 15 22.1699 16.6338 23.1699 18.3662 26 16.7324 26 20 28 20 28 16.7319 30.8301 18.3662 31.8301 16.6338 29 15 31.8301 13.3662z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m22,30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967,2.2399-5,5v5h-2v-5c.0045-3.8641,3.1359-6.9955,7-7h6c3.8641.0045,6.9955,3.1359,7,7v5Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m12,4c2.7614,0,5,2.2386,5,5s-2.2386,5-5,5-5-2.2386-5-5c.0031-2.7601,2.2399-4.9969,5-5m0-2c-3.866,0-7,3.134-7,7s3.134,7,7,7,7-3.134,7-7-3.134-7-7-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSponsor.propTypes = iconPropTypes;
}
const UserXRay = /*#__PURE__*/React.forwardRef(function UserXRay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M31,3H17a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V4A1,1,0,0,0,31,3ZM28,9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H13V26a2.9465,2.9465,0,0,0-3-3H6a2.9465,2.9465,0,0,0-3,3v4H1V26a4.9514,4.9514,0,0,1,5-5h4a4.9514,4.9514,0,0,1,5,5Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M8,11a3,3,0,0,1,0,6,3,3,0,0,1,0-6M8,9A5,5,0,0,0,8,19,5,5,0,0,0,8,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserXRay.propTypes = iconPropTypes;
}
const UserProfileAlt = /*#__PURE__*/React.forwardRef(function UserProfileAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H26V15H19z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H30V10H19z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H30V5H19z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30H7a2.0059,2.0059,0,0,1-2-2V21a2.0059,2.0059,0,0,1-2-2V13a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,11,30ZM6,12a.9448.9448,0,0,0-1,1v6H7v9h4V19h2V13a.9448.9448,0,0,0-1-1Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,9,9ZM9,3a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,9,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserProfileAlt.propTypes = iconPropTypes;
}
const UvIndex = /*#__PURE__*/React.forwardRef(function UvIndex({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UvIndex.propTypes = iconPropTypes;
}
const UvIndexAlt = /*#__PURE__*/React.forwardRef(function UvIndexAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30H9a2.0027,2.0027,0,0,1-2-2V20H9v8h4V20h2v8A2.0027,2.0027,0,0,1,13,30Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V7H15z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H7V17H2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UvIndexAlt.propTypes = iconPropTypes;
}
const UvIndexFilled = /*#__PURE__*/React.forwardRef(function UvIndexFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UvIndexFilled.propTypes = iconPropTypes;
}
const ValueVariable = /*#__PURE__*/React.forwardRef(function ValueVariable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H22V26h4V6H22V4h4a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H6a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,6,4h4V6H6V26h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ValueVariable.propTypes = iconPropTypes;
}
const Van = /*#__PURE__*/React.forwardRef(function Van({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Van.propTypes = iconPropTypes;
}
const VegetationAsset = /*#__PURE__*/React.forwardRef(function VegetationAsset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "10.5",
    r: "1.5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,1a2.4518,2.4518,0,0,0-1.2061.3105L18.9834,5.6084l.0027.0054a5.497,5.497,0,1,0,7.3257,7.5444l.0031.0015,4.4-8.5A2.5,2.5,0,0,0,28.5,1Zm-7,13A3.5,3.5,0,1,1,25,10.5,3.5042,3.5042,0,0,1,21.5,14ZM28.9414,3.7354,26.5571,8.3408A5.5279,5.5279,0,0,0,23.658,5.4424l4.5949-2.377A.5165.5165,0,0,1,29,3.5.4985.4985,0,0,1,28.9414,3.7354Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M19,20h7V18H17V28a2.0027,2.0027,0,0,0,2,2h3V28H19Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0024,2.0024,0,0,1,12,30Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VegetationAsset.propTypes = iconPropTypes;
}
const VegetationEncroachment = /*#__PURE__*/React.forwardRef(function VegetationEncroachment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m19,20h7v-2h-9v10c.0015,1.104.896,1.9985,2,2h3v-2h-3v-8Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m12,30h-3v-2h3v-12.4336l-3.5146-2.1089,1.0292-1.7148,3.5147,2.1084c.6007.3632.9686,1.0133.9707,1.7153v12.4336c-.0013,1.104-.896,1.9987-2,2Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.4102L28.59 5 25 8.5898 21.41 5 20 6.4102 23.59 10 20 13.5898 21.41 15 25 11.4102 28.59 15 30 13.5898 26.41 10 30 6.4102z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m17.3079,2.2852c-.7283-.1821-1.4995-.2852-2.3079-.2852-2.8545.0083-5.4897,1.5317-6.9214,4.001-.0261-.001-.0522-.001-.0786-.001-3.3137,0-6,2.6865-6,6s2.6863,6,6,6v-2c-2.209,0-4-1.791-4-4s1.791-4,4-4c.1299.0039.259.0166.387.0391l.863.1143.3086-.6675c.9834-2.1196,3.1047-3.4785,5.4414-3.4858.6079,0,1.1819.0854,1.731.2148l.5769-1.9297Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VegetationEncroachment.propTypes = iconPropTypes;
}
const VegetationHeight = /*#__PURE__*/React.forwardRef(function VegetationHeight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m13,8l-5,5,1.4102,1.4102,2.5898-2.5801v16.1699h-3v2h3c1.104-.0015,1.9988-.896,2-2V11.8301l2.5898,2.5801,1.4102-1.4102-5-5Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m22,30h-3c-1.104-.0013-1.9987-.896-2-2v-11h6c2.2096-.0001,4.0007-1.7915,4.0006-4.001,0-.1319-.0065-.2637-.0196-.395-.277-2.0943-2.0835-3.6461-4.1957-3.604h-1.5837l-.1766-.779c-.573-2.5249-2.9942-4.221-6.025-4.221-2.3366.0074-4.4579,1.3664-5.4415,3.4859l-.3085.6672-.863-.1143c-.1279-.022-.2573-.0349-.387-.0388-2.2091,0-4,1.7909-4,4s1.7909,4,4,4v2c-3.3137,0-6-2.6863-6-6s2.6863-6,6-6c.0264,0,.0525,0,.0786.001,1.4317-2.4694,4.067-3.9928,6.9214-4.001,3.6788,0,6.6923,1.9776,7.7516,5h.0337c3.1405-.0351,5.8053,2.2967,6.1872,5.4141.323,3.2985-2.0892,6.2344-5.3877,6.5573-.1943.019-.3895.0286-.5848.0286h-4v9h3v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VegetationHeight.propTypes = iconPropTypes;
}
const VehicleApi = /*#__PURE__*/React.forwardRef(function VehicleApi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a1.9907,1.9907,0,0,0-.8247.1821L24.8337,9.51A3.45,3.45,0,0,0,25,8.5a3.45,3.45,0,0,0-.1663-1.01l2.3416-1.6723A1.9975,1.9975,0,1,0,26,4c0,.064.0129.124.0188.1865L23.7273,5.8232A3.4652,3.4652,0,0,0,21.5,5a3.5,3.5,0,0,0,0,7,3.4652,3.4652,0,0,0,2.2273-.8232l2.2915,1.6367C26.0129,12.876,26,12.936,26,13a2,2,0,1,0,2-2Zm-6.5-1A1.5,1.5,0,1,1,23,8.5,1.5017,1.5017,0,0,1,21.5,10Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,19.9336l-7.7324-2.7783L18.374,13.0967A2.99,2.99,0,0,0,16.0537,12H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,17.2949A4.9884,4.9884,0,0,0,2,20.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V20.875A1,1,0,0,0,29.3379,19.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V20.1074A2.9977,2.9977,0,0,1,4.52,18.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,14h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,21.5781Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleApi.propTypes = iconPropTypes;
}
const VehicleConnected = /*#__PURE__*/React.forwardRef(function VehicleConnected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11H23a2.0021,2.0021,0,0,0-2-2V7A4.0045,4.0045,0,0,1,25,11Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleConnected.propTypes = iconPropTypes;
}
const VehicleInsights = /*#__PURE__*/React.forwardRef(function VehicleInsights({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V9H28z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H26V9H24z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H22V9H20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleInsights.propTypes = iconPropTypes;
}
const VehicleServices = /*#__PURE__*/React.forwardRef(function VehicleServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5547,6a2,2,0,0,1,2-2H30a3.9756,3.9756,0,0,0-7.304,1H16V7h6.696A3.9756,3.9756,0,0,0,30,8H26.5547A2,2,0,0,1,24.5547,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleServices.propTypes = iconPropTypes;
}
const Version = /*#__PURE__*/React.forwardRef(function Version({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Version.propTypes = iconPropTypes;
}
const VersionMajor = /*#__PURE__*/React.forwardRef(function VersionMajor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 17.4141L16 14.8345 16 14.8345 13.4125 17.4156 12 16 16 12 20 16 18.5859 17.4141z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 11.4141L16 8.8345 16 8.8345 13.4125 11.4156 12 10 16 6 20 10 18.5859 11.4141z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 23.4141L16 20.8345 16 20.8345 13.4125 23.4156 12 22 16 18 20 22 18.5859 23.4141z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VersionMajor.propTypes = iconPropTypes;
}
const VersionMinor = /*#__PURE__*/React.forwardRef(function VersionMinor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 15.4141L16 12.8345 16 12.8345 13.4125 15.4156 12 14 16 10 20 14 18.5859 15.4141z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 21.4141L16 18.8345 16 18.8345 13.4125 21.4156 12 20 16 16 20 20 18.5859 21.4141z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VersionMinor.propTypes = iconPropTypes;
}
const VersionPatch = /*#__PURE__*/React.forwardRef(function VersionPatch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 18.4141L16 15.8345 16 15.8345 13.4125 18.4156 12 17 16 13 20 17 18.5859 18.4141z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VersionPatch.propTypes = iconPropTypes;
}
const VerticalView = /*#__PURE__*/React.forwardRef(function VerticalView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2h8a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,12,30ZM4,4V28h8V4Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H20a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM20,4V28h8V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VerticalView.propTypes = iconPropTypes;
}
const Video = /*#__PURE__*/React.forwardRef(function Video({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Video.propTypes = iconPropTypes;
}
const VideoAdd = /*#__PURE__*/React.forwardRef(function VideoAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoAdd.propTypes = iconPropTypes;
}
const VideoChat = /*#__PURE__*/React.forwardRef(function VideoChat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H17V14H8z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H13V19H8z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoChat.propTypes = iconPropTypes;
}
const VideoFilled = /*#__PURE__*/React.forwardRef(function VideoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoFilled.propTypes = iconPropTypes;
}
const VideoOff = /*#__PURE__*/React.forwardRef(function VideoOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46,8.11a1,1,0,0,0-1,.08L23,12.06V10.44l7-7L28.56,2,2,28.56,3.44,30l4-4H21a2,2,0,0,0,2-2V19.94l5.42,3.87A1,1,0,0,0,30,23V9A1,1,0,0,0,29.46,8.11ZM28,21.06l-5.42-3.87A1,1,0,0,0,21,18v6H9.44L21,12.44V14a1,1,0,0,0,1.58.81L28,10.94Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M4,24V8H20V6H4A2,2,0,0,0,2,8V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoOff.propTypes = iconPropTypes;
}
const VideoOffFilled = /*#__PURE__*/React.forwardRef(function VideoOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M20.31,6H4A2,2,0,0,0,2,8V24a2.85,2.85,0,0,0,0,.29Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46,8.11a1,1,0,0,0-1,.08L23,12.06V10.44l7-7L28.56,2,2,28.56,3.44,30l4-4H21a2,2,0,0,0,2-2V19.94l5.42,3.87A1,1,0,0,0,30,23V9A1,1,0,0,0,29.46,8.11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoOffFilled.propTypes = iconPropTypes;
}
const VideoPlayer = /*#__PURE__*/React.forwardRef(function VideoPlayer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13 21 21 16 13 11z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "m28,6H4c-1.103,0-2,.8975-2,2v16c0,1.1025.897,2,2,2h24c1.103,0,2-.8975,2-2V8c0-1.1025-.897-2-2-2Zm0,18H4V8h24v16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoPlayer.propTypes = iconPropTypes;
}
const View = /*#__PURE__*/React.forwardRef(function View({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
      d: "M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3 c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5 C13.4,10.5,10.6,12.5,8,12.5z"
    })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
      d: "M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  View.propTypes = iconPropTypes;
}
const ViewFilled = /*#__PURE__*/React.forwardRef(function ViewFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewFilled.propTypes = iconPropTypes;
}
const ViewMode_1 = /*#__PURE__*/React.forwardRef(function ViewMode_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H28V21H4z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v6H6V6H26m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewMode_1.propTypes = iconPropTypes;
}
const ViewMode_2 = /*#__PURE__*/React.forwardRef(function ViewMode_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H28V21H4z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6v6H6V6h6m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v6H20V6h6m0-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewMode_2.propTypes = iconPropTypes;
}
const ViewOff = /*#__PURE__*/React.forwardRef(function ViewOff({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
      d: "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
    })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
      d: "M6,7.9c0.1-1,0.9-1.8,1.8-1.8l0.9-0.9C7.2,4.7,5.5,5.6,5.1,7.2C5,7.7,5,8.3,5.1,8.8L6,7.9z"
    })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
      d: "M15.5,7.8c-0.6-1.5-1.6-2.8-2.9-3.7L15,1.7L14.3,1L1,14.3L1.7,15l2.6-2.6c1.1,0.7,2.4,1,3.7,1.1c3.3-0.1,6.3-2.2,7.5-5.3 C15.5,8.1,15.5,7.9,15.5,7.8z M10,8c0,1.1-0.9,2-2,2c-0.3,0-0.7-0.1-1-0.3L9.7,7C9.9,7.3,10,7.6,10,8z M8,12.5c-1,0-2.1-0.3-3-0.8 l1.3-1.3c1.4,0.9,3.2,0.6,4.2-0.8c0.7-1,0.7-2.4,0-3.4l1.4-1.4c1.1,0.8,2,1.9,2.6,3.2C13.4,10.5,10.6,12.5,8,12.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15.73a4,4,0,0,1,3.7-3.7l1.81-1.82a6,6,0,0,0-7.33,7.33Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.4,16.4,0,0,0,25.2,8.22L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.1A15.29,15.29,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM20,16a4,4,0,0,1-6,3.44L19.44,14A4,4,0,0,1,20,16Zm-4,9a13.05,13.05,0,0,1-6-1.58l2.54-2.54a6,6,0,0,0,8.35-8.35l2.87-2.87A14.54,14.54,0,0,1,28.93,16C26.9,21.07,21.3,25,16,25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewOff.propTypes = iconPropTypes;
}
const ViewOffFilled = /*#__PURE__*/React.forwardRef(function ViewOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66a16.4,16.4,0,0,0-5.73-7.45L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.09A15.38,15.38,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5a6.46,6.46,0,0,1-3.83-1.26L14,19.43A4,4,0,0,0,19.43,14l1.81-1.81A6.49,6.49,0,0,1,16,22.5Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53,21.81l5-5A6.84,6.84,0,0,1,9.5,16,6.51,6.51,0,0,1,16,9.5a6.84,6.84,0,0,1,.79.05l3.78-3.77A14.39,14.39,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A15.86,15.86,0,0,0,4.53,21.81Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewOffFilled.propTypes = iconPropTypes;
}
const ViewNext = /*#__PURE__*/React.forwardRef(function ViewNext({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewNext.propTypes = iconPropTypes;
}
const VirtualColumn = /*#__PURE__*/React.forwardRef(function VirtualColumn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H20a2.0023,2.0023,0,0,1-2-2V6a2.0023,2.0023,0,0,1,2-2H30V6H20V26H30Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H2V26H12V6H2V4H12a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,12,28Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualColumn.propTypes = iconPropTypes;
}
const VirtualColumnKey = /*#__PURE__*/React.forwardRef(function VirtualColumnKey({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualColumnKey.propTypes = iconPropTypes;
}
const VirtualDesktop = /*#__PURE__*/React.forwardRef(function VirtualDesktop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualDesktop.propTypes = iconPropTypes;
}
const VirtualMachine = /*#__PURE__*/React.forwardRef(function VirtualMachine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualMachine.propTypes = iconPropTypes;
}
const VirtualPrivateCloud = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualPrivateCloud.propTypes = iconPropTypes;
}
const VirtualPrivateCloudAlt = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["VirtualPrivateCloudAlt"]) {
      didWarnAboutDeprecation["VirtualPrivateCloudAlt"] = true;
      console.warn("Icon name was requested by the product team to be renamed to and replaced by ibm-cloud--vpc. As a result, the VirtualPrivateCloudAlt component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a3.9915,3.9915,0,0,0-7.8579-1H13V7h9.1421A3.9945,3.9945,0,0,0,25,9.8579V19h2V9.8579A3.9962,3.9962,0,0,0,30,6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H9.8579A3.9945,3.9945,0,0,0,7,22.1421V13H5v9.1421A3.9915,3.9915,0,1,0,9.8579,27H19ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualPrivateCloudAlt.propTypes = iconPropTypes;
}
const VisualRecognition = /*#__PURE__*/React.forwardRef(function VisualRecognition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VisualRecognition.propTypes = iconPropTypes;
}
const Vlan = /*#__PURE__*/React.forwardRef(function Vlan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Vlan.propTypes = iconPropTypes;
}
const VlanIbm = /*#__PURE__*/React.forwardRef(function VlanIbm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,22Zm0,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,16,28Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M30,5a3,3,0,1,0-4,2.8154V15H17V9H15v6H6V7.8159a3.0007,3.0007,0,1,0-2,0V15a2.002,2.002,0,0,0,2,2h9v3h2V17h9a2.002,2.002,0,0,0,2-2V7.8159A2.9958,2.9958,0,0,0,30,5ZM5,4A1,1,0,1,1,4,5,1.0013,1.0013,0,0,1,5,4ZM27,6a1,1,0,1,1,1-1A1.0013,1.0013,0,0,1,27,6Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "5",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VlanIbm.propTypes = iconPropTypes;
}
const VmdkDisk = /*#__PURE__*/React.forwardRef(function VmdkDisk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VmdkDisk.propTypes = iconPropTypes;
}
const VoiceActivate = /*#__PURE__*/React.forwardRef(function VoiceActivate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325,25.2168a7.0007,7.0007,0,0,1,0-10.4341l1.334,1.49a5,5,0,0,0,0,7.4537Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VoiceActivate.propTypes = iconPropTypes;
}
const Voicemail = /*#__PURE__*/React.forwardRef(function Voicemail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Voicemail.propTypes = iconPropTypes;
}
const VolumeBlockStorage = /*#__PURE__*/React.forwardRef(function VolumeBlockStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H10V14h7Zm-5-2h3V16H12Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30H10V23h7Zm-5-2h3V25H12Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M26,21H19V14h7Zm-5-2h3V16H21Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H19V23h7Zm-5-2h3V25H21Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeBlockStorage.propTypes = iconPropTypes;
}
const VolumeDown = /*#__PURE__*/React.forwardRef(function VolumeDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1,10.66,23.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a1,1,0,0,1-.71-.3L11.67,22H5a1,1,0,0,1-1-1H4V11a1,1,0,0,1,1-1h6.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,21,3V29A1,1,0,0,1,20,30ZM6,20h6a1.17,1.17,0,0,1,.79.3L19,26.57V5.43L12.79,11.7A1.17,1.17,0,0,1,12,12H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDown.propTypes = iconPropTypes;
}
const VolumeDownAlt = /*#__PURE__*/React.forwardRef(function VolumeDownAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30ZM4,20h6a1.2008,1.2008,0,0,1,.7939.2969L17,26.5684V5.4316l-6.2061,6.2715A1.2013,1.2013,0,0,1,10,12H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownAlt.propTypes = iconPropTypes;
}

export { QU1, QU2, QU3, TriangleDownOutline, TriangleDownSolid, TriangleLeftOutline, TriangleLeftSolid, TriangleOutline, TriangleRightOutline, TriangleRightSolid, TriangleSolid, Trigger, Trophy, TrophyFilled, TropicalStorm, TropicalStormModelTracks, TropicalStormTracks, TropicalWarning, Tsq, Tsunami, Tsv, Tuning, TwoFactorAuthentication, TwoPersonLift, Txt, TxtReference, TypePattern, Types, Umbrella, Undefined, UndefinedFilled, Undo, UngroupObjects, Unknown, UnknownFilled, Unlink, Unlocked, Unsaved, UpToTop, UpdateNow, Upgrade, Upload, Upstream, Url, UsageIncludedUseCase, Usb, UseCaseDefinition, UseCaseUsage, User, UserAccess, UserAccessLocked, UserAccessUnlocked, UserActivity, UserAdmin, UserAvatar, UserAvatarFilled, UserAvatarFilledAlt, UserCertification, UserData, UserFavorite, UserFavoriteAlt, UserFavoriteAltFilled, UserFeedback, UserFilled, UserFollow, UserIdentification, UserMilitary, UserMultiple, UserOnline, UserProfile, UserProfileAlt, UserRole, UserService, UserServiceDesk, UserSettings, UserSimulation, UserSpeaker, UserSponsor, UserXRay, UvIndex, UvIndexAlt, UvIndexFilled, ValueVariable, Van, VegetationAsset, VegetationEncroachment, VegetationHeight, VehicleApi, VehicleConnected, VehicleInsights, VehicleServices, Version, VersionMajor, VersionMinor, VersionPatch, VerticalView, Video, VideoAdd, VideoChat, VideoFilled, VideoOff, VideoOffFilled, VideoPlayer, View, ViewFilled, ViewMode_1, ViewMode_2, ViewNext, ViewOff, ViewOffFilled, VirtualColumn, VirtualColumnKey, VirtualDesktop, VirtualMachine, VirtualPrivateCloud, VirtualPrivateCloudAlt, VisualRecognition, Vlan, VlanIbm, VmdkDisk, VoiceActivate, Voicemail, VolumeBlockStorage, VolumeDown, VolumeDownAlt };
